// Employee file uploads (API UserUploadController, route api/users/uploads).
// Enums travel as numbers: the API has no string enum converter.

// UserUploadStatus
export const USER_UPLOAD_STATUS_QUEUED = 1;
export const USER_UPLOAD_STATUS_IN_PROGRESS = 2;
export const USER_UPLOAD_STATUS_COMPLETED = 3;
export const USER_UPLOAD_STATUS_COMPLETED_WITH_ERRORS = 4;
export const USER_UPLOAD_STATUS_FAILED = 5;

export const USER_UPLOAD_FINAL_STATUSES = [
  USER_UPLOAD_STATUS_COMPLETED,
  USER_UPLOAD_STATUS_COMPLETED_WITH_ERRORS,
  USER_UPLOAD_STATUS_FAILED,
];

export const USER_UPLOAD_STATUS_LABELS = {
  [USER_UPLOAD_STATUS_QUEUED]: "user_upload_status_queued",
  [USER_UPLOAD_STATUS_IN_PROGRESS]: "user_upload_status_in_progress",
  [USER_UPLOAD_STATUS_COMPLETED]: "user_upload_status_completed",
  [USER_UPLOAD_STATUS_COMPLETED_WITH_ERRORS]:
    "user_upload_status_completed_with_errors",
  [USER_UPLOAD_STATUS_FAILED]: "user_upload_status_failed",
};

export const USER_UPLOAD_STATUS_SEVERITIES = {
  [USER_UPLOAD_STATUS_QUEUED]: "info",
  [USER_UPLOAD_STATUS_IN_PROGRESS]: "info",
  [USER_UPLOAD_STATUS_COMPLETED]: "success",
  [USER_UPLOAD_STATUS_COMPLETED_WITH_ERRORS]: "warning",
  [USER_UPLOAD_STATUS_FAILED]: "danger",
};

// UserUploadRowResult
export const USER_UPLOAD_ROW_ADDED = 1;
export const USER_UPLOAD_ROW_UPDATED = 2;
export const USER_UPLOAD_ROW_SKIPPED = 3;
export const USER_UPLOAD_ROW_FAILED = 4;

export const USER_UPLOAD_ROW_RESULT_LABELS = {
  [USER_UPLOAD_ROW_ADDED]: "user_upload_result_added",
  [USER_UPLOAD_ROW_UPDATED]: "user_upload_result_updated",
  [USER_UPLOAD_ROW_SKIPPED]: "user_upload_result_skipped",
  [USER_UPLOAD_ROW_FAILED]: "user_upload_result_failed",
};

// API error codes (400 body errorCode, spec 4.2; 404 body response for a
// download) and the message shown for each. UPLOAD_DOWNLOAD_FAILED is the
// UI's own, for a download 404 without one of these codes.
export const USER_UPLOAD_ERROR_MESSAGES = {
  UPLOAD_NOT_XLSX: "user_upload_error_not_xlsx",
  UPLOAD_TOO_LARGE: "user_upload_error_too_large",
  UPLOAD_TOO_MANY_ROWS: "user_upload_error_too_many_rows",
  UPLOAD_UNKNOWN_COLUMN: "user_upload_error_unknown_column",
  UPLOAD_DUPLICATE_COLUMN: "user_upload_error_duplicate_column",
  UPLOAD_MISSING_COLUMN: "user_upload_error_missing_column",
  UPLOAD_NO_ROWS: "user_upload_error_no_rows",
  UPLOAD_FILES_EXPIRED: "user_upload_files_expired_message",
  UPLOAD_FILES_MISSING: "user_upload_files_missing_message",
  UPLOAD_DOWNLOAD_FAILED: "user_upload_download_failed",
  FORBIDDEN: "no_permission",
};

// For these the API message names the column, so it is shown too.
export const USER_UPLOAD_COLUMN_ERRORS = [
  "UPLOAD_UNKNOWN_COLUMN",
  "UPLOAD_DUPLICATE_COLUMN",
  "UPLOAD_MISSING_COLUMN",
];

export const USER_UPLOAD_FILE_ORIGINAL = "original";
export const USER_UPLOAD_FILE_RESULTS = "results";

export const USER_UPLOAD_POLL_INTERVAL_MS = 3000;
export const USER_UPLOAD_MAX_FILE_BYTES = 10 * 1024 * 1024;
export const USER_UPLOAD_FILE_TYPE = ".xlsx";
